import React, { useState } from 'react';
import FormInput from '../common/FormInput';
import FormButton from '../common/FormButton';
import { authService } from '../../../services/api';

const ForgotPasswordForm = ({ onNavigate }) => {
  const [email, setEmail] = useState('');
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setErrors({});
    
    try {
      await authService.requestPasswordReset(email);
      setSuccess(true);
    } catch (error) {
      if (error.type === 'validation_error') {
        setErrors(error.errors);
      } else {
        setErrors({ general: error.message });
      }
    } finally {
      setLoading(false);
    }
  };

  if (success) {
    return (
      <div className="text-center space-y-6">
        <div className="mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-green-100">
          <svg className="h-6 w-6 text-green-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
          </svg>
        </div>
        
        <div>
          <h3 className="text-lg font-medium text-gray-900 mb-2">Check your email</h3>
          <p className="text-gray-600">
            We've sent a password reset link to <strong>{email}</strong>
          </p>
        </div>
        
        <div className="text-sm text-gray-500">
          <p>Didn't receive the email? Check your spam folder or</p>
          <button
            onClick={() => setSuccess(false)}
            className="text-blue-600 hover:text-blue-800 font-medium"
          >
            try again
          </button>
        </div>
        
        <div className="pt-4">
          <button
            onClick={() => onNavigate('login')}
            className="text-blue-600 hover:text-blue-800 text-sm font-medium transition-colors"
          >
            ← Back to login
          </button>
        </div>
      </div>
    );
  }

  return (
    <form onSubmit={handleSubmit} className="space-y-6">
      {errors.general && (
        <div className="bg-red-50 border border-red-200 text-red-700 px-4 py-3 rounded-md">
          {errors.general}
        </div>
      )}

      <div className="text-center">
        <h3 className="text-lg font-medium text-gray-900 mb-2">Reset your password</h3>
        <p className="text-gray-600">
          Enter your email address and we'll send you a link to reset your password.
        </p>
      </div>

      <FormInput
        label="Email Address"
        type="email"
        name="email"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        placeholder="Enter your email"
        required
        error={errors.email}
      />

      <FormButton
        type="submit"
        loading={loading}
        disabled={loading}
      >
        Send Reset Link
      </FormButton>

      <div className="text-center">
        <button
          onClick={() => onNavigate('login')}
          className="text-blue-600 hover:text-blue-800 text-sm font-medium transition-colors"
        >
          ← Back to login
        </button>
      </div>
    </form>
  );
};

export default ForgotPasswordForm;
